import { TravelCurrencyCode } from '@graphql/generated';
import { useGeoBasedLocale } from './useGeoLocale';

export const useTravelWhiteLabelCurrency = (): [TravelCurrencyCode, { loading: boolean }] => {
  const { loading, currency: localeCurrency } = useGeoBasedLocale();
  if (loading) {
    return [TravelCurrencyCode.USD, { loading }]; // Default currency while loading
  }
  const currency = localeCurrency as keyof typeof TravelCurrencyCode;
  const validCurrencyCode = TravelCurrencyCode[currency] || TravelCurrencyCode.USD;
  return [validCurrencyCode, { loading }];
};
